import Swal from 'sweetalert2';

export function useToast() {
  // Configuración base estilo "Bootstrap/Material"
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 6000,
    timerProgressBar: true,
    width: 'clamp(300px, 90%, 450px)',
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });

  const showSuccess = (message) => {
    Toast.fire({
      icon: 'success',
      title: message,
      background: '#fff',
      color: '#1f2937' // Slate-800
    });
  };

  const showError = (message) => {
    Toast.fire({
      icon: 'error',
      title: 'Ocurrió un error',
      text: message,
      background: '#fff',
      color: '#1f2937'
    });
  };

  const showWarning = (message) => {
    Toast.fire({
      icon: 'warning',
      title: message,
      background: '#fff',
      color: '#1f2937'
    });
  };

  return {
    showSuccess,
    showError,
    showWarning
  };
}